// extracted by mini-css-extract-plugin
export default {"container":"BarcodeScanner_container__PJzIz","code":"BarcodeScanner_code__ze3Cu","clear":"BarcodeScanner_clear__UCVfY"};